import React from "react";
import ReactDOM from "react-dom";

function renderHiddenModal() {
  ReactDOM.render(<div />, document.getElementById("modal-container"));
}

export async function hideModal() {
  renderHiddenModal();
}
